import { configureStore } from "@reduxjs/toolkit";
import { gradeFileSlide } from "../slices/gradeFileSlide";
import { masterSlice } from "../slices/masterSlice";
import authSlice from "../slices/authSlice";
import practiceRoomSlide from "../slices/practiceRoomSlice";

const store = configureStore({
  reducer: {
    auth: authSlice.reducer,
    gradeFile: gradeFileSlide.reducer,
    master: masterSlice.reducer,
    practiceRoom: practiceRoomSlide.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export default store;
